import { render, staticRenderFns } from "./ManageTicketsTemplate.vue?vue&type=template&id=b6765b9e&scoped=true&"
import script from "./ManageTicketsTemplate.vue?vue&type=script&lang=js&"
export * from "./ManageTicketsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ManageTicketsTemplate.vue?vue&type=style&index=0&id=b6765b9e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6765b9e",
  null
  
)

export default component.exports